import axios from 'axios'
import { ElMessage } from 'element-plus'

const api_config=  {
    baseURL: "https://scavcapi.yidaimingjvn.xyz/api/",
    // baseURL: "http://localhost:9090/api/",
    timeout: 50000
}
const API = axios.create(
    api_config
)

// 请求拦截器
API.interceptors.request.use(
    function (config) {
        return config
    },
    function (error) {
        // 对请求错误做些什么
        if(error.config.url == "/student/answer/download"){
            ElMessage.error("校验失败，用户上传文件不存在")
        }else{
            ElMessage.error(error.message)
        }
        // location.href="/"
        return Promise.reject(error);
    }
)

// 响应拦截器
API.interceptors.response.use(
    function (response) {

        return response;
    }, 
    function (error) {
        // 超出 2xx 范围的状态码都会触发该函数。
        // 对响应错误做点什么
        if(error.config.url == "/student/answer/download"){
            ElMessage.error("校验失败，用户上传文件不存在")
        }else{
            ElMessage.error(error.message)
        }
        return Promise.reject(error);
    }
)


export default API